import { useState, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

interface StoryStepProps {
  label: string;
  tag?: ReactNode;
  collapsedStats?: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function StoryStep({ label, tag, collapsedStats, children, defaultOpen = false }: StoryStepProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`story-cd${open ? ' story-acc-open' : ''}`}>
      <div className="story-acc-trigger" onClick={() => setOpen(o => !o)}>
        <div className="story-cd-hd">
          <span className="story-cd-lbl">{label}</span>
          {tag}
        </div>
        <div className="story-acc-summary">
          {collapsedStats}
        </div>
        <div className="story-acc-chev">
          <ChevronDown />
        </div>
      </div>
      <div className="story-acc-body">
        {children}
      </div>
    </div>
  );
}
